export const LANG = {
  'ca': {
    global: {
      menu_home: 'Inici',
      menu_web: 'Web del Museu'
    },
    home: {
      title: 'Benvinguts'
    },
    node: {
      audio: 'Notes de veu',
      gallery: 'Galeria',
      links: 'Enllaços d\'interés',
      info: 'Informació'
    },
    term: {
      getThere: 'Com arribar?'
    }
  },
  'es': {
    global: {
      menu_home: 'Inicio',
      menu_web: 'Web del Museo'
    },
    home: {
      title: 'Bienvenidos'
    },
    node: {
      audio: 'Notas de voz',
      gallery: 'Galería',
      links: 'Enlaces de interés',
      info: 'Información'
    },
    term: {
      getThere: '¿Cómo llegar?'
    }
  },
  'en': {
    global: {
      menu_home: 'Home',
      menu_web: 'Museum website'
    },
    home: {
      title: 'Welcome'
    },
    node: {
      audio: 'Audio tracks',
      gallery: 'Gallery',
      links: 'External links',
      info: 'Information'
    },
    term: {
      getThere: 'How to get there?'
    }
  }
}
